import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import Instructions from "containers/request/OTA/OTADeviceInfoBubble";
import RequestManufacturer from "components/request/RequestManufacturer";
import RequestModelName from "components/request/RequestModelnameSimple";
import BatteryVoltageCapacity from "components/request/BatteryVoltageCapacity";
import RequestRevision from "components/request/RequestRevision";
import RequestParentLink from "components/request/RequestParentLink";
import BatteryParentDetails from "components/request/BatteryParentDetails";
import PackCellsReadonly from "components/request/PackCellsReadonly";
import NonSarSitesReadonly from "containers/request/battery/NonSarSites/NonSarSitesReadonly";
import SubmissionDetails from "containers/request/RequestContent/SubmissionDetails";
import RequestDescChanges from "components/request/RequestDescChanges";
import { initPRR } from "actions/battery/prrRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";

const DeviceInfoLabPRR = ({ request, initPRR, mapNonSarManufSites }) => {
  useEffect(() => {
    if (!request.id) {
      initPRR(null).then(() => {
        mapNonSarManufSites(request.linkedManufsites);
      });
    }
  }, [initPRR, mapNonSarManufSites, request]);

  return (
    <div>
      <Instructions />
      <Form horizontal>
        {request.isEco && (
          <>
            <RequestParentLink certPrefix="prr" />
            <BatteryParentDetails />
            <hr />
          </>
        )}
        <RequestManufacturer />
        <RequestModelName />
        <hr />
        <RequestRevision fieldId="revision" editable={false} />
        {request.isEco && <RequestDescChanges />}
        <BatteryVoltageCapacity />
        <SubmissionDetails />
        <hr />
        <NonSarSitesReadonly />
        <hr />
        <PackCellsReadonly />
      </Form>
    </div>
  );
};

function mapStateToProps({ request, sites }) {
  return { request, sites };
}

export default connect(mapStateToProps, {
  initPRR,
  mapNonSarManufSites
})(DeviceInfoLabPRR);
